"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNWRAP_TASK = exports.DELAY_TASK = exports.ACTION_TASK = exports.LOAD_CLOUD_MAP_TASK = exports.EXPORT_FILE_TO_CLOUD_TASK = exports.LOAD_MAP_STYLE_TASK = exports.PROCESS_FILE_DATA = exports.LOAD_FILE_TASK = void 0;

var _tasks = _interopRequireWildcard(require("react-palm/tasks"));

var _d3Request = require("d3-request");

var _processors = require("@kepler.gl/processors");

// SPDX-License-Identifier: MIT
// Copyright contributors to the kepler.gl project
var LOAD_FILE_TASK = _tasks["default"].fromPromise(function (_ref) {
  var file = _ref.file,
      fileCache = _ref.fileCache,
      loaders = _ref.loaders,
      loadOptions = _ref.loadOptions;
  return (0, _processors.readFileInBatches)({
    file: file,
    fileCache: fileCache,
    loaders: loaders,
    loadOptions: loadOptions
  });
}, 'LOAD_FILE_TASK');

exports.LOAD_FILE_TASK = LOAD_FILE_TASK;

var PROCESS_FILE_DATA = _tasks["default"].fromPromise(_processors.processFileData, 'PROCESS_FILE_CONTENT');

exports.PROCESS_FILE_DATA = PROCESS_FILE_DATA;
var LOAD_MAP_STYLE_TASK = (0, _tasks.taskCreator)(function (_ref2, success, error) {
  var url = _ref2.url,
      id = _ref2.id;
  return (0, _d3Request.json)(url, function (err, result) {
    if (err) {
      error(err);
    } else {
      if (!result) {
        error(new Error('Map style response is empty'));
      }

      success({
        id: id,
        style: result
      });
    }
  });
}, 'LOAD_MAP_STYLE_TASK');
/**
 * task to upload file to cloud provider
 */

exports.LOAD_MAP_STYLE_TASK = LOAD_MAP_STYLE_TASK;

var EXPORT_FILE_TO_CLOUD_TASK = _tasks["default"].fromPromise(function (_ref3) {
  var provider = _ref3.provider,
      payload = _ref3.payload;
  return provider.uploadMap(payload);
}, 'EXPORT_FILE_TO_CLOUD_TASK');

exports.EXPORT_FILE_TO_CLOUD_TASK = EXPORT_FILE_TO_CLOUD_TASK;

var LOAD_CLOUD_MAP_TASK = _tasks["default"].fromPromise(function (_ref4) {
  var provider = _ref4.provider,
      payload = _ref4.payload;
  return provider.downloadMap(payload);
}, 'LOAD_CLOUD_MAP_TASK');
/**
 *  task to dispatch a function as a task
 */


exports.LOAD_CLOUD_MAP_TASK = LOAD_CLOUD_MAP_TASK;

var ACTION_TASK = _tasks["default"].fromCallback(function (_, cb) {
  return cb();
}, 'ACTION_TASK');

exports.ACTION_TASK = ACTION_TASK;

var DELAY_TASK = _tasks["default"].fromCallback(function (delay, cb) {
  return window.setTimeout(function () {
    return cb();
  }, delay);
}, 'DELAY_TASK');

exports.DELAY_TASK = DELAY_TASK;

var UNWRAP_TASK = _tasks["default"].fromPromise(function (promise) {
  return promise;
}, 'UNWRAP');

exports.UNWRAP_TASK = UNWRAP_TASK;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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